<div *ngIf="loading | async">
    <div class="loading-state">
        <div class="loading"></div>
    </div>
</div>